import React from "react";
import { useNavigate } from "react-router-dom";
import { Globe } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Global Language Switcher Button
 * Appears on all pages and allows users to change language at any time
 */
const LanguageSwitcher = ({ className = "" }) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  
  // Language labels for display
  const languageLabels = {
    en: "EN",
    es: "ES",
    fr: "FR",
    ar: "عر",
    zh: "中",
    ja: "日",
    ko: "한",
    vi: "VI",
    th: "ไทย"
  };

  const currentLang = languageLabels[i18n.language] || "EN";

  const handleClick = () => {
    navigate("/language-select");
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center gap-1.5 px-3 py-2 rounded-full bg-white/90 backdrop-blur-sm border border-slate-200 shadow-sm hover:shadow-md hover:border-slate-300 transition-all duration-200 group ${className}`}
      aria-label="Change language"
      data-testid="language-switcher"
    >
      <Globe className="w-4 h-4 text-slate-600 group-hover:text-[#0EA5E9] transition-colors" />
      <span className="text-sm font-semibold text-slate-700 group-hover:text-[#0EA5E9] transition-colors">
        {currentLang}
      </span>
    </button>
  );
};

export default LanguageSwitcher;
